import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../providers/rest.service';
import {ToastrService} from 'ngx-toastr';
import {Master} from '../model/master';

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css']
})
export class MasterComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  id: string = null;
  master: Master = null;

  entities: string[] = [
    Master.ParaBirimi,
    Master.OdemeYontemi,
    Master.TeslimYeri,
    Master.TeslimSekli,
    Master.Sehir,
    Master.SarfYeri,
    Master.FaturaTipi,
    Master.Lokasyon,
    Master.UrunCinsi,
    Master.AracTipi,
  ];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private restService: RestService,
              private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.id = params.id;
      if (this.id !== '0') {
        this.getEntity();
      } else {
        this.master = new Master();
        //this.master.id = Number(0);
        this.master.kodu = '';
        this.master.aciklama = '';
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getEntity() {
    this.restService.getEntity(this.id).subscribe(res => {
      if (res) {
        this.master = res;
      }
    });
  }

  save() {
    const subscription = res => {
      this.toastrService.success('Kaydedildi', 'Başarılı');
      this.router.navigate(['master-list']);
    };
    if (this.id === '0') {
      this.restService.masterEkle(this.master).subscribe(subscription);
    } else {
      this.restService.masterDuzenle(this.master).subscribe(subscription);
    }
  }
}
